import { FC, PropsWithChildren } from "react";
import { SnackbarProvider } from "notistack";

import { ApiProviderFirebase } from "@dzambalaorg/provider-api-firebase";
import { UserProviderFirebase } from "@dzambalaorg/provider-user-firebase";
import { ReduxProvider, createStore } from "@dzambalaorg/redux";
import { ThemeProvider, layoutSlice } from "@dzambalaorg/provider-theme";
import { LicenseProvider } from "@dzambalaorg/provider-license";
import { LocalizationProvider, localizationSlice } from "@dzambalaorg/provider-localization";
import { collectionSlice } from "@dzambalaorg/provider-collection";
import { PopupProvider } from "@dzambalaorg/provider-popup";
import { WagmiRainbowProvider } from "@dzambalaorg/provider-wagmi";
import { EnabledLanguages, ns } from "@framework/constants";
import { i18n } from "@framework/localization-public-ui";

import { themeProps } from "../components/theme";

export const Providers: FC<PropsWithChildren> = props => {
  const { children } = props;
  return (
    <ReduxProvider store={createStore([collectionSlice, localizationSlice, layoutSlice])}>
      <ApiProviderFirebase baseUrl={process.env.BE_URL} storageName={ns}>
        <LicenseProvider licenseKey={process.env.GEMUNION_API_KEY}>
          <UserProviderFirebase>
            <ThemeProvider {...themeProps}>
              <LocalizationProvider i18n={i18n} defaultLanguage={EnabledLanguages.EN}>
                <SnackbarProvider>
                  <PopupProvider>
                    <WagmiRainbowProvider redirectLogoutPath={"/"} redirectLoginPath={"/"}>
                      {children}
                    </WagmiRainbowProvider>
                  </PopupProvider>
                </SnackbarProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </UserProviderFirebase>
        </LicenseProvider>
      </ApiProviderFirebase>
    </ReduxProvider>
  );
};
